import { atom, useAtom, useSetAtom } from "jotai";

export const defaultPosOrderHandOverDate = { day: "", time: "", isAsap: true };

export const posOrderHandOverDateAtom = atom<{
  day: string;
  time: string;
  isAsap: boolean;
}>(defaultPosOrderHandOverDate);

const usePosOrderHandOverDate = () => {
  const atom = useAtom(posOrderHandOverDateAtom);
  return atom;
};

export const useSetPosOrderHandOverDate = () =>
  useSetAtom(posOrderHandOverDateAtom);

export default usePosOrderHandOverDate;
